import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Link from './common/TrackedLink';
import ButtonLink from './common/TrackedButtonLink';
import ProductImageCTA from './common/ProductImageCTA';
import LazyLoad from 'react-lazyload';
import VideoLeftTextRight from "./components/page/VideoLeftTextRight";
import config from "../config";

import InsightsCards from './components/InsightsCards';

import { PRODUCT_SELECTOR } from "../constants/app";
import { dataLayerPush } from "../utils";
import Testimonial from "./category/common/Testimonial";
import {
	buildEcomProductArrayForTopProducts,
	pushCardCtaItem,
	pushCardItem,
	pushNewEcommerceEvent
} from "../utils/datalayer";
import CmsContentWrapper from "./common/CmsContentWrapper";
import TrackedLink from "./common/TrackedLink";
import TrackedButtonLink from "./common/TrackedButtonLink";
import TopProducts from "./category/common/TopProducts";
import InView from "./common/InView";


class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mobile: false
		};
		this.handleTopProductsInview = this.handleTopProductsInview.bind(this);
	}

	componentDidMount() {
		if (window.innerWidth < 768) {
			this.state.mobile = true;
		}
	}

	handleTopProductsInview() {
		const {products} = this.props;
		const items = buildEcomProductArrayForTopProducts(products, undefined, 'All Best Selling Products');
		pushNewEcommerceEvent('view_item_list', items);
	}

	render() {

		// console.dir(this.props.products);
		const promotions = this.props.promotions;
		const leftPromo = this.props.promotions.bottomPromotion[0];
		const rightPromo = this.props.promotions.bottomPromotion[1];
		const insights = this.props.insights;

		let promoLeftBackgroundSize = '40%';
		let promoLeftBackgroundPosition = '93% center';

		let promoRightBackgroundSize = '40%';
		let promoRightBackgroundPosition = '93% center';

		if (leftPromo.backgroundColor === 'transparent') {
			promoLeftBackgroundSize = 'cover';
			promoLeftBackgroundPosition = '80% top';
		}
		if (rightPromo.backgroundColor === 'transparent') {
			promoRightBackgroundSize = 'cover';
			promoRightBackgroundPosition = '80% top';
		}

		let headerTextClass = promotions.topPromo.headerTextClass;
		let detailTextClass = promotions.topPromo.detailTextClass;

		//If mobile, remove class names so text is black
		if (this.state.mobile === true) {
			headerTextClass = "";
			detailTextClass = "";
		}

		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.products != null) {

			const productImageCta = this.props.products.map((product, index) => (
				<ProductImageCTA
					key={index}
					imgSrc={product.image}
					title={product.description}
					listPrice={product.priceBucket}
					modelNumber={product.modelNumber}
				/>
			));
			topProducts = (
				<section className="row safes-callout">
					<div className="col sm-3 callout-descr">
						<h2 className="section-title">Best&#45;Selling Products</h2>
						<p>The most versatile protection SentrySafe has to offer.</p>
						<ButtonLink className="btn-primary" to="/products?bestOfBest=true" id="ctaHomeViewAllBestSellingProducts">
							View All Best-Selling Products
						</ButtonLink>
					</div>
					<div className="col sm-9 products">
						<ul>
							{productImageCta}
						</ul>
					</div>
				</section>
			);
		}

		const videoTextData = {
			titleText: "SentrySafe Fireproof Safe vs. Other Brands",
			descriptionText: `<p><b>Watch the video</b> of our SentrySafe fireproof safe as it goes head-to-head with other brands in a one-hour fire test. Built to withstand temperatures up to 1700°, SentrySafe shows why it’s the only choice for protecting your valuables. <a href="/learn/fire-and-water-safes">Learn more about our next generation fireproof safes</a>.</p>`,
			videoUrl: 'https://fbinsecurity.widen.net/view/video/tsnmwwj5je/?u=tbvfmm'
		};

		return (
			<div className="container home">
				<Helmet
					htmlAttributes={{
						itemscope: undefined,
						itemtype : 'https://schema.org/WebSite',
					}}
					link={[{
						rel : 'canonical',
						href: 'https://www.sentrysafe.com/'
					}]}
				>
					<title>SentrySafe® Official Site | Pistol Safes & Fire Safes</title>
					<meta name="description"
						  content="SentrySafe offers a broad range of secure storage solutions to keep your valuables protected from unexpected perils, theft and more. View safes."/>
					<script async src={config.bazaarVoiceScriptUrl}/>
				</Helmet>
				<header className="home-hero">
					<img
						className="hero-image"
						src={promotions.topPromo.image.uri}
						alt={promotions.topPromo.image.altText}
					/>
					<div className="hero-content dark">
						<div className="row">
							<div className="col md-6 mt-md-5 pt-md-5">
								<h1 className={`mb-md-3 title uppercase ${headerTextClass}`}>{promotions.topPromo.headerText}</h1>
								<CmsContentWrapper html={promotions.topPromo.detailText} as="p" className={`mb-md-5 ${detailTextClass}`} />
								<ButtonLink
									to={promotions.topPromo.button.url}
									id="ctaHomeHeroTopPromo"
									className="btn-primary"
									target={promotions.topPromo.button.target}
									rel="noopener">
									{promotions.topPromo.button.label}
								</ButtonLink>
							</div>
						</div>
					</div>
				</header>

				<section>
					<div className="row dual-promo">

						<div className="col md-6 p-3 p-md-5" style={{
							backgroundSize    : `${promoLeftBackgroundSize}`,
							backgroundColor   : `${leftPromo.backgroundColor}`,
							backgroundRepeat  : 'no-repeat',
							backgroundImage   : `url(${leftPromo.image.uri})`,
							backgroundPosition: `${promoLeftBackgroundPosition}`

						}}>
							<div className="text-white">
								<h1 className="title">
									<span
										className={`block h2 mt-2 mb-3 ${leftPromo.headerTextClass}`}>{leftPromo.headerText}</span>
								</h1>
								<h2 className={`text-transform-none block h4 mt-2 mb-5 promo-text ${leftPromo.detailTextClass}`}
									dangerouslySetInnerHTML={{__html: leftPromo.detailText}}></h2>
								<ButtonLink
									to={leftPromo.button.url}
									id="ctaHomeHeroLeftPromo"
									className="btn-link icon-after"
									target={leftPromo.button.target}
									rel="noopener">
									{leftPromo.button.label}
								</ButtonLink>
							</div>
						</div>
						<div className="col md-6 p-3 p-md-5" style={{
							backgroundSize    : `${promoRightBackgroundSize}`,
							backgroundColor   : `${rightPromo.backgroundColor}`,
							backgroundRepeat  : 'no-repeat',
							backgroundImage   : `url(${rightPromo.image.uri})`,
							backgroundPosition: `${promoRightBackgroundPosition}`
						}}>

							<div className="uppercase text-white">
								<h1 className="title promo-text">
									<span className="block h2 text-white mt-2 mb-3">{rightPromo.headerText}</span>
								</h1>
								<h2 className="block h4 mt-2 mb-4 promo-text text-transform-none"
									dangerouslySetInnerHTML={{__html: rightPromo.detailText}}></h2>
								<ButtonLink
									to={rightPromo.button.url}
									id="ctaHomeHeroRightPromo"
									className="btn-link icon-after"
									target={rightPromo.button.target}
									rel="noopener">
									{rightPromo.button.label}
								</ButtonLink>
							</div>
						</div>
					</div>
				</section>

				<InView onInView={this.handleTopProductsInview}>
					<TopProducts
						topProduct={this.props.products}
						title="Best&#45;Selling Products"
						subTitle="The most versatile protection SentrySafe has to offer."
						buttonCTA="View All Best-Selling Products"
						path="/products?bestOfBest=true" />
				</InView>

				<section className="row pb-5">
					<VideoLeftTextRight data={videoTextData}/>
				</section>

				<div className="product-feature" style={{
					backgroundColor: '#cccccc',
					padding        : '56px 20px'
				}}>
					<div className="feature-image">
						<img src={require('../resources/img/ss-banner-583x299-012424.png')} alt=""/>
					</div>
					<div className="feature-content">
						<h2 className="feature-title feature-title--large">
							Not sure what<br/> you&rsquo;re looking for?
						</h2>
						<p>We&rsquo;ll help you find the right safe for your needs.</p>
						<TrackedButtonLink to={PRODUCT_SELECTOR.URL} target={PRODUCT_SELECTOR.TARGET} id="ctaHomeFindYourSafe" className="btn btn-primary">
							Find your safe
						</TrackedButtonLink>
					</div>
				</div>

				<Testimonial
					imgSrc1={ require('../resources/img/callouts/testimonial-jason-f.jpg')}
					alt1={ 'Scott&rsquo;s Story' }
					imgSrc2={ require('../resources/img/callouts/testimonial-quote.png') }
					alt2={ 'Quote' }
					quote={ 'I&#39;ve owned the 3100 safe since I was 9 or 10 years old. Recently had a house fire where we lost everything&#8230;Our safe fell through 2 floors and was trapped in the rubble for 4 days. After letting it cool down, we cut through the steel&#8230;To my surprise, everything inside the safe was saved!' }
					submitted={ 'Jason F.' }
					readLink={ 'View all SentrySafe Stories' }
					link={ '/learn/customer-stories' }
				/>

				{/*<section className="row feature-callout callout-alt">*/}
				{/*	<div className="col sm-5 sm-hide">*/}
				{/*		<LazyLoad once={true} offset={200}>*/}
				{/*			<img*/}
				{/*				src={require('../resources/img/callouts/flood.jpg')}*/}
				{/*				alt="Man observing his flooded home"*/}
				{/*			/>*/}
				{/*		</LazyLoad>*/}
				{/*	</div>*/}
				{/*	<div className="col sm-7 content">*/}
				{/*		<div>*/}
				{/*			<img*/}
				{/*				className="icon"*/}
				{/*				src={require('../resources/img/icons/fire-icon.png')}*/}
				{/*				srcSet={`${require('../resources/img/icons/fire-icon@2x.png')} 2x`}*/}
				{/*				alt="Fire Resistant"*/}
				{/*			/>*/}
				{/*			<img*/}
				{/*				className="icon"*/}
				{/*				src={require('../resources/img/icons/water-icon.png')}*/}
				{/*				srcSet={`${require('../resources/img/icons/water-icon@2x.png')} 2x`}*/}
				{/*				alt="Water Resistant"*/}
				{/*			/>*/}
				{/*			<h3>Water &amp; Fire Protection</h3>*/}
				{/*			<p>Safeguard your belongings from the most unexpected perils.</p>*/}
				{/*			<ButtonLink className="btn-primary" to="/fire-waterproof-safes">*/}
				{/*				Learn about water &amp; fire safes*/}
				{/*			</ButtonLink>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</section>*/}

				<section className="card-container my-5">
					<div className="card">
						<Link
							to="/learn/buying-guide"
							onClick={(e) => {pushCardItem(e)}}>
							<div>
								<img
									src={require('../resources/img/callouts/promo-left.jpg')}
									alt="Locked safe"
								/>
							</div>
							<div className="card-body">
								<h2>Which Safe Is Right For You?</h2>
								<p>We’ll help you find the best safe to fit your needs, so you can start protecting
									what’s most valuable to you.</p>
								<div className="pt-4">
									<span
										className="btn btn-primary"
										onClick={e => {pushCardCtaItem(e)}}>Learn More</span>
								</div>
							</div>
						</Link>
					</div>
					<div className="card col-md-10 col-lg-4">
						<Link
							to="/support/lost-key-combo"
							onClick={(e) => {pushCardItem(e)}}>
							<div>
								<img
									src={require('../resources/img/callouts/promo-center.jpg')}
									alt="Safe with a key in the lock"
								/>
							</div>
							<div className="card-body">
								<h2>Lost Your Key or Combination?</h2>
								<p>With our easy key &amp; combo replacement process, you can quickly request a new
									combination or replacement key.</p>
								<div className="pt-4">
									<span
										className="btn btn-primary"
										onClick={e => {pushCardCtaItem(e)}}>Get Started</span>
								</div>
							</div>
						</Link>
					</div>
					<div className="card col-md-10 col-lg-4">
						<Link
							to="https://www.masterlock.com/next-gen-lock-boxes"
							onClick={(e) => {pushCardItem(e)}} target="_blank">
							<div>
								<img
									src={require('../resources/img/callouts/promo-nglb.jpg')}
									alt="Close up of hand using a Next Generation Shared Access Box"
								/>
							</div>
							<div className="card-body">
								<h2>The Next Generation of Shared Access from Master Lock. </h2>
								<p>More storage. More flexibility. Easier to use.</p>
								<div className="pt-4">
									<span
										className="btn btn-primary"
										onClick={e => {pushCardCtaItem(e)}}><span className="fa fa-external-link"></span> Learn More</span>
								</div>
							</div>
						</Link>
					</div>
				</section>
				<InsightsCards data={insights}/>
				{/* <section className="row d-flex flex-column flex-md-row feature-callout callout-alt">

					<div className="col sm-5 pt-5 px-5 px-md-2 py-md-5 order-md-last">
						<a className="d-block feature-image grayscale mx-auto mx-md-0" onClick={() => this.handlePromoClick()} href="https://insights.masterlock.com/" target="_blank" rel="noopener">
							<img className="shadow" src={require('../resources/img/callouts/safety-Insights-landing-page.jpg')} alt="" />
						</a>
					</div>

					<div className="d-block text-center col sm-7 content order-md-first">
						<h3 className="m-0">Uncover Insights</h3>
						<p>Access relevant resources to help you live a safer, more secure life.</p>
						<ButtonLink className="d-inline-block btn btn-primary" to="https://insights.masterlock.com/" target="_blank" rel="noopener">
							<span className="fa fa-external-link"></span> Learn More <span className="assistive-text"> and Uncover Insights</span>
						</ButtonLink>
					</div>
				</section> */}

			</div>
		);
	}
}

export default branch({
	products  : ['product', 'featuredProduct', 'products'],
	promotions: ['promotions'],
	insights: ['insights'],
}, Home);


// WEBPACK FOOTER //
// ./src/pages/Home.js